import { DefaultHtmlAttributes } from "@syncfusion/ej2-react-base";
import {
  TooltipComponent,
  TooltipModel,
  TooltipTypecast,
} from "@syncfusion/ej2-react-popups";
import { FC, ReactNode } from "react";
import { sanitizeHtml } from "../../utils/markup";

export type TooltipPropType = TooltipModel &
  DefaultHtmlAttributes &
  TooltipTypecast;

export interface TooltipV2Props extends Omit<TooltipPropType, "content"> {
  shouldShowTooltip: boolean;
  content: string;
  children?: ReactNode;
}

export const RelativityTooltipV2: FC<TooltipV2Props> = ({
  shouldShowTooltip,
  content,
  children,
  ...otherProps
}) => {
  let tooltipContent: HTMLElement = document.createElement("div");
  tooltipContent.className = "ucl-tooltip-content";
  tooltipContent.innerHTML = sanitizeHtml(content);

  return shouldShowTooltip ? (
    <div>
      <TooltipComponent
        closeDelay={250}
        {...otherProps}
        content={tooltipContent}
      >
        {children}
      </TooltipComponent>
    </div>
  ) : (
    <>{children}</>
  );
};
